import { createSlice } from "@reduxjs/toolkit";
import { nanoid } from "nanoid";
var initialState = {
    notifications: []
};
var notificationsSlice = createSlice({
    initialState: initialState,
    name: "notifications",
    reducers: {
        newNotification: function(state, param) {
            var payload = param.payload;
            var _payload_header;
            var newNotification = {
                header: (_payload_header = payload.header) !== null && _payload_header !== void 0 ? _payload_header : "",
                id: "".concat(payload.type, "-").concat(nanoid()),
                message: payload.message,
                type: payload.type
            };
            var exists = state.notifications.some(function(notification) {
                return notification.message === newNotification.message && notification.type === newNotification.type && notification.header === newNotification.header;
            });
            if (!exists) {
                state.notifications.push(newNotification);
            }
        },
        removeNotification: function(state, param) {
            var payload = param.payload;
            state.notifications = state.notifications.filter(function(param) {
                var id = param.id;
                return id !== payload;
            });
        },
        reset: function() {
            return initialState;
        }
    }
});
var _notificationsSlice_actions = notificationsSlice.actions;
export var newNotification = _notificationsSlice_actions.newNotification, removeNotification = _notificationsSlice_actions.removeNotification;
export var notificationsReducer = notificationsSlice.reducer;

//# sourceMappingURL=notifications.js.map